import { render, staticRenderFns } from "./DetailsDownloadList.vue?vue&type=template&id=65fdc39b&scoped=true"
import script from "./DetailsDownloadList.vue?vue&type=script&lang=js"
export * from "./DetailsDownloadList.vue?vue&type=script&lang=js"
import style0 from "./DetailsDownloadList.vue?vue&type=style&index=0&id=65fdc39b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fdc39b",
  null
  
)

export default component.exports